/* Norvek — PDP behaviours. Sem dependências. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- galeria ---------- */
  function initGallery(root) {
    if (root.dataset.nvReady) return;
    var track = root.querySelector('[data-nv-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nv-thumb]'));
    if (!track || !thumbs.length) return;
    root.dataset.nvReady = '1';

    var counter = root.querySelector('[data-nv-counter]');
    var total = thumbs.length;

    function select(i) {
      thumbs.forEach(function (t) {
        var on = Number(t.dataset.nvThumb) === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', String(on));
      });
      if (counter) counter.textContent = (i + 1) + '/' + total;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = Number(thumb.dataset.nvThumb);
        var slide = track.querySelector('[data-nv-slide="' + i + '"]');
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
        select(i);
      });
    });

    // swipe manual mantém thumbs e contador em sincronia.
    // Os slides não ocupam 100% da largura (há peek no mobile), por isso
    // procuramos o slide cujo offsetLeft está mais perto do scroll actual.
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-nv-slide]'));
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var x = track.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - x);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        select(best);
      });
    }, { passive: true });
  }

  /* ---------- barra fixa ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-nv-sticky]');
    var buy = document.getElementById('nv-buy');
    if (!bar || !buy || bar.dataset.nvReady) return;

    bar.dataset.nvReady = '1';
    bar.hidden = false;

    // mostra quando a zona de compra sai de vista; esconde quando volta
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-in', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -20% 0px' });
    io.observe(buy);

    var cta = bar.querySelector('[data-nv-sticky-cta]');
    if (cta) {
      cta.addEventListener('click', function (ev) {
        ev.preventDefault();
        buy.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.nv-reveal');
    if (!items.length) return;
    if (reduced) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- reseña destacada da buybox ---------- */
  function initBbrev(root) {
    if (root.dataset.nvReady) return;
    var track = root.querySelector('[data-nv-bbrev-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nv-bbrev-dot]'));
    if (!track || dots.length < 2) return;
    root.dataset.nvReady = '1';

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-nv-bbrev-slide]'));

    function select(i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function current() {
      var x = track.scrollLeft, best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function goTo(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      select(i);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { kill(); goTo(Number(dot.dataset.nvBbrevDot)); });
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; select(current()); });
    }, { passive: true });

    /* autoplay, como na Frostly: pára ao primeiro gesto e não regressa */
    var delay = Number(root.dataset.autoplay || 0) * 1000;
    var timer = null;
    var killed = false;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (timer || killed || !delay || reduced) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        goTo((current() + 1) % slides.length);
      }, delay);
    }

    /* Um gesto DELIBERADO mata o autoplay de vez: arrastar o carrossel,
       clicar num ponto, usar o teclado. Não `wheel` nem `touchstart` no
       root — rolar a página com o ponteiro por cima matava-o antes de
       começar. O rato apenas PAUSA enquanto está por cima. */
    function kill() { killed = true; stop(); }
    track.addEventListener('pointerdown', kill, { passive: true, once: true });
    root.addEventListener('keydown', kill, { once: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // só anda quando está à vista
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.4 });
    io.observe(root);
  }

  /* ---------- carrossel de reseñas (só quando há scroll: mobile/tablet) ---------- */
  function initReviews(root) {
    if (root.dataset.nvReady) return;
    var track = root.querySelector('[data-nv-rv-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nv-rv-dot]'));
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-nv-rv-slide]')) : [];
    if (!track || slides.length < 2) return;
    root.dataset.nvReady = '1';

    function scrollable() { return track.scrollWidth - track.clientWidth > 8; }

    function select(i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function current() {
      var x = track.scrollLeft, best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function goTo(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      select(i);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { kill(); goTo(Number(dot.dataset.nvRvDot)); });
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; select(current()); });
    }, { passive: true });

    /* autoplay: pára ao primeiro gesto do utilizador e não volta */
    var delay = Number(root.dataset.autoplay || 0) * 1000;
    var timer = null;
    var killed = false;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (timer || killed || !delay || reduced || !scrollable()) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        var next = (current() + 1) % slides.length;
        goTo(next);
      }, delay);
    }

    /* Um gesto DELIBERADO mata o autoplay de vez: arrastar o carrossel,
       clicar num ponto, usar o teclado. Não `wheel` nem `touchstart` no
       root — rolar a página com o ponteiro por cima matava-o antes de
       começar. O rato apenas PAUSA enquanto está por cima. */
    function kill() { killed = true; stop(); }
    track.addEventListener('pointerdown', kill, { passive: true, once: true });
    root.addEventListener('keydown', kill, { once: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // só corre quando a secção está à vista
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.25 });
    io.observe(root);

    // ao passar para desktop deixa de haver scroll: desliga
    window.addEventListener('resize', function () { if (!scrollable()) stop(); }, { passive: true });
  }

  /* ---------- carrossel de passos (só mobile) ---------- */
  function initSteps(root) {
    if (root.dataset.nvReady) return;
    var track = root.querySelector('[data-nv-steps-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nv-steps-dot]'));
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-nv-steps-slide]')) : [];
    if (!track || slides.length < 2) return;
    root.dataset.nvReady = '1';

    function scrollable() { return track.scrollWidth - track.clientWidth > 8; }
    function select(i) { dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }
    function current() {
      var x = track.scrollLeft, best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft - x);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function goTo(i) {
      var s = slides[i]; if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      select(i);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { kill(); goTo(Number(dot.dataset.nvStepsDot)); });
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; select(current()); });
    }, { passive: true });

    var delay = Number(root.dataset.autoplay || 0) * 1000;
    var timer = null, killed = false;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (timer || killed || !delay || reduced || !scrollable()) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        goTo((current() + 1) % slides.length);
      }, delay);
    }
    function kill() { killed = true; stop(); }
    track.addEventListener('pointerdown', kill, { passive: true, once: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.25 });
    io.observe(root);
    window.addEventListener('resize', function () { if (!scrollable()) stop(); }, { passive: true });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    if (root.dataset.nvFaqReady) return;
    root.dataset.nvFaqReady = '1';

    root.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-nv-faq-q]');
      if (!btn || !root.contains(btn)) return;

      var item = btn.closest('.nv-faq__item');
      var open = item.dataset.open === 'true';

      // acordeão: só uma aberta de cada vez
      root.querySelectorAll('.nv-faq__item[data-open="true"]').forEach(function (other) {
        if (other === item) return;
        other.dataset.open = 'false';
        other.querySelector('[data-nv-faq-q]').setAttribute('aria-expanded', 'false');
      });

      item.dataset.open = String(!open);
      btn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- CTA da oferta ---------- */
  function initOfferCta() {
    var buy = document.getElementById('nv-buy');
    if (!buy) return;
    document.querySelectorAll('[data-nv-offer-cta]').forEach(function (cta) {
      if (cta.dataset.nvReady) return;
      cta.dataset.nvReady = '1';
      cta.addEventListener('click', function (ev) {
        ev.preventDefault();
        buy.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-nv-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-nv-bbrev]').forEach(initBbrev);
    document.querySelectorAll('[data-nv-rv]').forEach(initReviews);
    document.querySelectorAll('[data-nv-steps]').forEach(initSteps);
    document.querySelectorAll('[data-nv-faq]').forEach(initFaq);
    initSticky();
    initReveal();
    initOfferCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // o editor de temas recarrega secções sem recarregar a página
  document.addEventListener('shopify:section:load', boot);
})();
